import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ManagementState } from '../reducers/management.reducer';

export const selectManagementState =
  createFeatureSelector<ManagementState>('management');

export const selectMyManagementAssignments = createSelector(
  selectManagementState,
  (state) => state?.myAssignments || []
);

export const selectOrganizationAssignments = createSelector(
  selectManagementState,
  (state) => state?.organizationAssignments || []
);

export const selectCurrentOrganization = createSelector(
  selectManagementState,
  (state) => state?.currentOrganization || null
);

export const selectHierarchyNodes = createSelector(
  selectManagementState,
  (state) => state?.nodes || []
);

export const selectSelectedNodeId = createSelector(
  selectManagementState,
  (state) => state?.selectedNodeId || null
);

export const selectSelectedNode = createSelector(
  selectHierarchyNodes,
  selectSelectedNodeId,
  (nodes, selectedId) => nodes.find((n) => n.id === selectedId) || null
);

export const selectAffiliatedChurches = createSelector(
  selectManagementState,
  (state) => state?.affiliatedChurches || []
);

export const selectSelectedChurchId = createSelector(
  selectManagementState,
  (state) => state?.selectedChurchId || null
);

export const selectSelectedChurch = createSelector(
  selectAffiliatedChurches,
  selectSelectedChurchId,
  (churches, churchId) =>
    churchId ? churches.find((c) => c.id === churchId) || null : null
);

export const selectChurchesForSelectedNode = createSelector(
  selectAffiliatedChurches,
  selectSelectedNode,
  (churches, selectedNode) => {
    if (!selectedNode) return [];
    return churches.filter((c) => c.parentNodeId === selectedNode.id);
  }
);

export const selectNodeLeaders = createSelector(
  selectManagementState,
  (state) => state?.nodeLeaders || []
);

export const selectChurchOversight = createSelector(
  selectManagementState,
  (state) => state?.churchOversight || null
);

export const selectManagementViewMode = createSelector(
  selectManagementState,
  (state) => state?.viewMode || 'canvas'
);

export const selectManagementLoading = createSelector(
  selectManagementState,
  (state) => state?.loading || false
);

export const selectMyOrganizations = createSelector(
  selectManagementState,
  (state) => state?.myOrganizations || []
);

export const selectLoadingMyOrganizations = createSelector(
  selectManagementState,
  (state) => state?.loadingMyOrganizations || false
);

export const selectOrganizationMembers = createSelector(
  selectManagementState,
  (state) => state?.members || []
);

export const selectActiveOrganizationMembers = createSelector(
  selectOrganizationMembers,
  (members) => members.filter((m) => m.status === 'active')
);

export const selectPendingOrganizationMembers = createSelector(
  selectOrganizationMembers,
  (members) => members.filter((m) => m.status === 'requested')
);

export const selectInvitedOrganizationMembers = createSelector(
  selectOrganizationMembers,
  (members) => members.filter((m) => m.status === 'invited')
);

export const selectLoadingMembers = createSelector(
  selectManagementState,
  (state) => state?.loadingMembers || false
);

export const selectMemberActionInProgress = createSelector(
  selectManagementState,
  (state) => state?.memberActionInProgress || false
);
